import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';

export default Vue.component('logistics-settings-card', {
  name: 'LogisticsSettingsCard',
  data () {
    let color: any
    return {
      cardExpanded: false,
      color: color,
      loadingTableData: false,
      errorMessage: '',
      logisticsSettingsData: [ { id: 1, task: '', reminderDaysBefore: '', dueDaysBefore: '', oldReminderDaysBefore: '', oldDueDaysBefore: '', isEditing: false, isSaving: false} ],
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
  },
  created: function () {
    if (this.cardExpanded) { this.getLogisticsSettings() } else { this.logisticsSettingsData = []; }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getLogisticsSettings()
      }
    },
    getLogisticsSettings () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingTableData = true;
      }, 200);
      self.errorMessage = ''
      HTTP.get('/api/logistics-settings/')
      .then(function (response) {
        let logisticsSettings = response.data.data;
        logisticsSettings.map(function (setting: any) { setting.isEditing = false; setting.isSaving = false; });
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingTableData = false;
        self.logisticsSettingsData = logisticsSettings;
      })
      .catch(function (error) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingTableData = false;
        self.errorMessage = error;
      })
    },
    editRow (logisticsSetting: any) {
      logisticsSetting.oldReminderDaysBefore = logisticsSetting.reminderDaysBefore;
      logisticsSetting.oldDueDaysBefore = logisticsSetting.dueDaysBefore;

      logisticsSetting.isEditing = !logisticsSetting.isEditing;
    },
    cancelEditRow (logisticsSetting: any) {
      if (logisticsSetting.id < 0) {
        let index = this.logisticsSettingsData.indexOf(logisticsSetting);
        this.logisticsSettingsData.splice(index, 1);
      }
      logisticsSetting.reminderDaysBefore = logisticsSetting.oldReminderDaysBefore;
      logisticsSetting.dueDaysBefore = logisticsSetting.oldDueDaysBefore;
      logisticsSetting.isEditing = !logisticsSetting.isEditing;
    },
    saveEditRow (logisticsSetting: any) {
      let self = this;
      logisticsSetting.isSaving = true;
      HTTP.put('/api/logistics-settings/', logisticsSetting)
        .then(function (response) {
          logisticsSetting.oldReminderDaysBefore = logisticsSetting.reminderDaysBefore;
          logisticsSetting.oldDueDaysBefore = logisticsSetting.dueDaysBefore;
          logisticsSetting.isEditing = !logisticsSetting.isEditing;
          logisticsSetting.isSaving = false;
        })
        .catch(function (error) {
          console.error('response Error!');
          console.log(error);
          logisticsSetting.isSaving = false;
          let errorMessages = [];
          let noErrorsFound = true;
          errorMessages.push( getRestParamErrorMessage(error, 'task') );
          errorMessages.push( getRestParamErrorMessage(error, 'reminderDaysBefore') );
          errorMessages.push( getRestParamErrorMessage(error, 'dueDaysBefore') );
          errorMessages.forEach(function (errorMessage) {
            if (!errorMessage.length) { return; }
            noErrorsFound = false;
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Updating Logistic Setting For a Task',
              text: errorMessage,
              duration: 5000
            });
          });
          if (noErrorsFound) {
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Updating Logistics Setting For a Task',
              text: generalError.length ? generalError : 'An error occurred updating logistics setting for a task.',
              duration: 5000
            });
          }
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/logisticsSettings/LogisticsSettingsCard.ts